module.exports = __webpack_public_path__ + "img/logo-dark.7d31e69b.svg";